/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamPauseReason } from './oralExamPauseReason';

export type OralExamAgentControlStateResponsePauseReason = OralExamPauseReason | null;
